import React from 'react';
import {useI18n} from '@shopify/react-i18n';
import {FiltersContainer} from 'sections/services-marketplace/experts/components';
import {TextContainer, Heading} from '@shopify/polaris';

export default function Filters() {
  const [i18n] = useI18n();

  return (
    <FiltersContainer>
      <TextContainer spacing="tight">
        <Heading>{i18n.translate('SavedExperts.Filters.label')}</Heading>
      </TextContainer>
    </FiltersContainer>
  );
}
